
const firstBlank = [
	"a little bit conflicted",
	"like Kanye",
	"not sure, but leaning towards yas queen",
	"mostly sure",
	"like this one is a no brainer",
	"hungry",
	"helpless and slightly drunk",
	"confused but still confident",
	"solidly undecided",
	"like I understand both sides",
	"funky mcdunky",
]

const secondBlank = [
	"will probably vote whatever my mom says. This is example text",
	"think I might cry into my voter guide. This is example text",
	"have more reading to do. This is example text",
	"am gonna go get a quinoa shake while I mull this over. This is example text",
	"am gonna check out Jane Kim's instagram. This is example text",
	"need a La Croix. This is example text",
	"wish you'd give me some advice. This is example text",
]

export const getPlaceholderText = () => {
	const placeholder ={
		first: firstBlank[Math.floor(Math.random() * firstBlank.length)],
		second: secondBlank[Math.floor(Math.random() * secondBlank.length)],
	}
	return placeholder;
}


// WEBPACK FOOTER //
// ./src/components/interactive/votePref/placeholder-text.js